export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url);
  }
}

// Google Analytics 4 (GA4) using gtag.js script, which is included in util/includeScripts.js
export class GoogleAnalyticsHandler {
  constructor() {
    this.initialized = false;
    this._checkInitialization();
  }

  _checkInitialization() {
    // Check if GA is already initialized
    if (window.gtag && window.dataLayer) {
      this.initialized = true;
      return;
    }

    // Try to initialize if not already done
    const { initGoogleAnalytics } = require('../util/googleAnalytics');
    this.initialized = initGoogleAnalytics();
  }

  trackPageView(canonicalPath, previousPath) {
    // Ensure GA is initialized
    if (!this.initialized) {
      this._checkInitialization();
    }

    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    if (window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
          page_location: window.location.href,
          page_title: document.title,
          previous_path: previousPath
        });
      }, 300);
    } else if (window.dataLayer) {
      // Fallback to dataLayer if gtag is not available
      window.dataLayer.push({
        event: 'page_view',
        page_path: canonicalPath,
        page_location: window.location.href,
        page_title: document.title,
        previous_path: previousPath
      });
    }
  }
}

export class GoogleTagManagerHandler {
  trackPageView(canonicalPath, previousPath) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: canonicalPath,
        previous_path: previousPath
      });
    }
  }

  trackSignup(userData) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'user_signup',
        signup_method: userData.publicData?.userType || 'standard',
        user_type: userData.publicData?.userType,
        practice_types: userData.publicData?.pub_practice_types,
        state: userData.publicData?.pub_State
      });
    }
  }
}
